var symphony = symphony || {};

;(function() {

	symphony.rowDonate = function() {

		var $rowDonate = $('.rowDonate');

		if($rowDonate.length <= 0) {
			return;
		}

		var donateSubmit = $rowDonate.find('.rowDonate-submit');
		var donateUrl = donateSubmit.attr('href');

		$rowDonate.find('.rowDonate-btn').on('click', function(e){
			e.preventDefault();

			// Declare variables
			var amount = $(this).text();
			var provides = $(this).data('provides');
			
			// Add active class
			$rowDonate.find('.rowDonate-btn').removeClass('isActive');
			$(this).addClass('isActive');

			// Update text based on chosen amount
			$rowDonate.find('.rowDonate-caption').addClass('isVisible');
			$rowDonate.find('.rowDonate-amount').text(amount);
			$rowDonate.find('.rowDonate-provides').text(provides);

			donateSubmit.attr('href', donateUrl + amount.replace("$", ""));
		});

	};


})();